import React, { useContext } from 'react';
import { t } from '../../common/components/T';
import { useTimer } from 'react-timer-hook';
import UserContext from '../../common/utils/getContext';
import moment from 'moment';
import { svgSprite } from '../../hybrid/wrappers';
import css from './Timer.module.scss';

const Timer = ({ date, styles, translation }) => {
    const expiryTimestamp = moment(date, 'MM/DD/YYYY HH:mm:ss').toDate();

    const { setAlertData } = useContext(UserContext);

    const { seconds, minutes } = useTimer({
        expiryTimestamp,
        onExpire: () => {
            setAlertData({
                type: 'error',
                cont: t('2fa_timeOut', 'Время вышло', 'widget', translation, 'modal2FA')
            });
        }
    });

    return (
        <div className={styles?.blockTime}>
            {svgSprite('clock', { className: css.blockClock })}
            {`${minutes} : ${seconds < 10 ? `0${seconds}` : seconds}`}
        </div>
    );
};
export default Timer;
